import { Box, Skeleton, Typography } from "@mui/material";
import { JSXElementConstructor, ReactElement } from "react";
import { useMedia } from "react-use";
import { ResponsiveContainer } from "recharts";

export default function ReportContainer({
  id,
  isLoading,
  title,
  children,
  hasLegend = false,
}: {
  id: string;
  isLoading: boolean;
  title: string;
  children: ReactElement<any, string | JSXElementConstructor<any>>;
  hasLegend?: boolean;
}) {
  let aspect = 2.5;
  const isMobile = useMedia("(max-width: 600px)");
  const isTablet = useMedia("(max-width: 960px)");
  const isWide = useMedia("(min-width: 1600px)");

  if (hasLegend) {
    aspect = isMobile ? 1 : isTablet ? 1.5 : isWide ? 2.5 : 2;
  } else {
    aspect = isMobile ? 1.5 : isTablet ? 2 : isWide ? 3 : 2.5;
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexDirection: "column",
        flexGrow: 1,
      }}
      data-test={`${id}-report`}
    >
      <Typography variant="h5" color={"secondary"} sx={{ ml: 3, mt: 3 }}>
        {title}
      </Typography>
      <ResponsiveContainer aspect={aspect} width="100%" debounce={300} minHeight={250}>
        {isLoading ? (
          <Skeleton height={"100%"} variant="rectangular" style={{ maxWidth: "100%" }} />
        ) : (
          children
        )}
      </ResponsiveContainer>
    </Box>
  );
}
